import type { Route } from '~/interfaces/routes.interfaces'

export const BASE_URL_ARCHIVE = '/archive'
const base = '/archive'

export const ARCHIVE_ARTICLE_ARCHIVED: Route = {
  path: `${base}/article-archived`
}

export const ARCHIVE_PRESS_REVIEW_ARCHIVED: Route = {
  path: `${base}/press-review-archived`
}
